module.exports = __webpack_public_path__ + "img/gyn_medical.e97d7782.png";